/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ats_Score_GreatInputs */

const en_onboarding_ats_score_great = /** @type {(inputs: Onboarding_Ats_Score_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Great start!`)
};

const de_onboarding_ats_score_great = /** @type {(inputs: Onboarding_Ats_Score_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guter Start!`)
};

const fr_onboarding_ats_score_great = /** @type {(inputs: Onboarding_Ats_Score_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bon début !`)
};

const es_onboarding_ats_score_great = /** @type {(inputs: Onboarding_Ats_Score_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Buen comienzo!`)
};

const it_onboarding_ats_score_great = /** @type {(inputs: Onboarding_Ats_Score_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottimo inizio!`)
};

const nl_onboarding_ats_score_great = /** @type {(inputs: Onboarding_Ats_Score_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goede start!`)
};

const pl_onboarding_ats_score_great = /** @type {(inputs: Onboarding_Ats_Score_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobry początek!`)
};

const fi_onboarding_ats_score_great = /** @type {(inputs: Onboarding_Ats_Score_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyvä alku!`)
};

const da_onboarding_ats_score_great = /** @type {(inputs: Onboarding_Ats_Score_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`God start!`)
};

const sv_onboarding_ats_score_great = /** @type {(inputs: Onboarding_Ats_Score_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bra start!`)
};

/**
* | output |
* | --- |
* | "Great start!" |
*
* @param {Onboarding_Ats_Score_GreatInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_ats_score_great = /** @type {((inputs?: Onboarding_Ats_Score_GreatInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ats_Score_GreatInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_ats_score_great(inputs)
	if (locale === "fr") return fr_onboarding_ats_score_great(inputs)
	if (locale === "es") return es_onboarding_ats_score_great(inputs)
	if (locale === "it") return it_onboarding_ats_score_great(inputs)
	if (locale === "nl") return nl_onboarding_ats_score_great(inputs)
	if (locale === "pl") return pl_onboarding_ats_score_great(inputs)
	if (locale === "fi") return fi_onboarding_ats_score_great(inputs)
	if (locale === "da") return da_onboarding_ats_score_great(inputs)
	if (locale === "sv") return sv_onboarding_ats_score_great(inputs)
	return en_onboarding_ats_score_great(inputs)
});